import axios from "axios";
import { GET_TEACHING_COURSES } from ".";
import { serverUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";

export const getTeachingCourses = () => {
  return (dispatch) => {
    return axios
      .get(serverUrl.TeachingCourses)
      .then((response) => {
        dispatch({
          type: GET_TEACHING_COURSES,
          payload: response.data,
        });
      })
      .catch((error) => {
        console.log(error);
        tokenAuthorize(error?.response?.status)
      });
  };
};
